export const DesignchairActions = {
    GET_DESIGNCHAIR_SECTION_DETAILS: "GET_DESIGNCHAIR_SECTION_DETAILS",
    SET_DESIGNCHAIR_SECTION_DETAILS: "SET_DESIGNCHAIR_SECTION_DETAILS",
  };